// extracted by mini-css-extract-plugin
export default {"contactIcon":"Contact_contactIcon__lxsRw","contactImgIcon":"Contact_contactImgIcon__m3DOn","links":"Contact_links__Vy6iI"};